export default __webpack_public_path__ + "static/media/ic_remove.9a39f6bf.svg";